
document.addEventListener('DOMContentLoaded', function () {
  const searchLinks = document.querySelectorAll('page-header .show-search-link');
  const searchDrawer = document.querySelector('.search_drawer');
  const searchClose = document.querySelector('.search_drawer .search_close');
  const ovelay_search = document.querySelector('.overlay');

  if (!searchDrawer) return;

  searchLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();

      searchDrawer.classList.add('active');
      ovelay_search.classList.add('is-visible');
    });
  });

  if (searchClose) {
    searchClose.addEventListener('click', function (event) {
      event.preventDefault();
 
      searchDrawer.classList.remove('active');
      ovelay_search.classList.remove('is-visible');
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {

  function moveRebuyProductActions() {
    document.querySelectorAll('.search_drawer .rebuy-product-grid').forEach(function (grid) {

      const mediaItems = grid.querySelectorAll('.rebuy-product-media');
      const actionItems = grid.querySelectorAll('.rebuy-product-actions');

      actionItems.forEach(function (actions, index) {
        const media = mediaItems[index];

        if (!media || !actions) return;

        // Don't append again if already moved
        if (actions.parentElement !== media) {
          media.appendChild(actions);
        }
      });

    });
  }

  moveRebuyProductActions();

  const observer = new MutationObserver(function () {
    moveRebuyProductActions();
  });

  observer.observe(document.querySelector('.search_drawer') || document.body, {
    childList: true,
    subtree: true
  });

});

document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll(
      '.section-main-article .article.article--main h1, ' +
      '.section-main-article .article.article--main h2, ' +
      '.section-main-article .article.article--main h3, ' +
      '.section-main-article .article.article--main h4, ' +
      '.section-main-article .article.article--main h5, ' +
      '.section-main-article .article.article--main h6'
    )
    .forEach(function (heading) {
      heading.removeAttribute('style');
    });
});

function updateSlideshowHeight() {
  const slideshow = document.querySelector('.main-banner-mobile .slideshow');
 
  if (!slideshow) return;
 
  const activeSlide = slideshow.querySelector(
    '.slideshow__slide.is-active'
  );
 
  if (!activeSlide) return;
 
  const imageOverlay = activeSlide.querySelector(
    '.image-overlay__image'
  );
 
  const textOverlay = activeSlide.querySelector(
    '.text-overlay'
  );
 
  if (!imageOverlay) return;
 
  // Only apply when the active slide does NOT have text
  if (!textOverlay) {
    const imageHeight = imageOverlay.offsetHeight;
 
    if (imageHeight > 0) {
      slideshow.style.height = `${imageHeight}px`;
    }
  } else {
    // Reset for slides that contain text
    slideshow.style.height = '';
  }
}
 
// Initial
document.addEventListener('DOMContentLoaded', updateSlideshowHeight);
 
// Resize
window.addEventListener('resize', updateSlideshowHeight);
 
// Detect active slide changes
const slideshow = document.querySelector('.slideshow');
 
if (slideshow) {
  const observers = new MutationObserver(() => {
    requestAnimationFrame(updateSlideshowHeight);
  });
 
  observers.observe(slideshow, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
}

document.addEventListener('click', function (event) {
  const loginToOrder = event.target.closest('.login-to-order');

  if (!loginToOrder) return;

  event.preventDefault();

  const accountLink = document.querySelector('.header-account-link');

  if (!accountLink) return;

  const shadowRoot = accountLink.shadowRoot;

  if (!shadowRoot) return;

  const accountButton = shadowRoot.querySelector('.account-button');

  if (accountButton) {
    accountButton.click();
  }
});


var root = document.querySelector('.main-banner-homepage.wyw-hero');
var link = root ? root.querySelector('a.text-overlay__button.small-feature-link[href="#open-wishlist"]') : null;

if (link) {
  root.addEventListener('click', function (e) {
    var a = e.target.closest('a.text-overlay__button.small-feature-link[href="#open-wishlist"]');

    if (a && root.contains(a)) {
      var drawerButton = document.querySelector('.swish-drawer-button');

      if (drawerButton) {
        e.preventDefault();
        drawerButton.click();
      }
    }
  });
}
